/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

interface ShowProps {
  when: boolean;
  children: React.ReactElement<any>;
}

const Show: React.StatelessComponent<ShowProps> = ({ when, children }) => (when ? children : null);

export default Show;
